export class CurveCreator {
  static createCurve(avgNUptake: number, value: number, threshold: number, min: number, max: number, factor: number): number[][] {
    if (value === undefined || threshold === undefined || Number.isNaN(threshold) || min === undefined ||
        max === undefined || Number.isNaN(min) || Number.isNaN(max) || factor === undefined) {
      return [[0, 0], [avgNUptake * 2, 0]];
    }
    const result = [];
    factor = (max - min) / 8 * factor;
    const n = value + factor * avgNUptake;
    const thresholdValue = -factor * threshold + n;
    if (thresholdValue > max) {
      result.push([0, min]);
      result.push([min * threshold / max, min]);
      result.push([threshold, max]);
      result.push([(max - n) / -factor, max]);
    } else if (thresholdValue < min) {
      result.push([0, min]);
      result.push([(min - n) / -factor, min]);
    } else {
      if (threshold !== 0) {
        result.push([0, min]);
        result.push([min * threshold / thresholdValue, min]);
      }
      result.push([threshold, thresholdValue]);
    }

    const end = -factor * avgNUptake * 2 + n;
    if (end < min) {
      result.push([(min - n) / -factor, min]);
      result.push([avgNUptake * 2, min]);
    } else if (end > max) {
      result.push([(max - n) / -factor, max]);
      result.push([avgNUptake * 2, max]);
    } else {
      result.push([avgNUptake * 2, end]);
    }
    return result;
  }

  static createNotes(avgNUptake: number, threshold: number): {
    value: number;
    color: string;
    label: string;
  }[] {
    const result = [
      {
        value: threshold,
        color: 'blue',
        label: 'Global__Threshold'
      }
    ];
    result.push({
      value: avgNUptake,
      color: 'green',
      label: 'AvgNUptakeShort'
    });
    return result;
  }
}
